
import { useCountriesData } from './useCountriesData';
import { useCountriesFilters } from './useCountriesFilters';
import { useCountriesPagination } from './useCountriesPagination';
import { useCountriesActions } from './useCountriesActions';

export const useCountries = () => {
  // Data management
  const { countries: allCountries, setCountries, isLoading, fetchCountries } = useCountriesData();
  
  // Filtering
  const {
    filteredCountries,
    searchQuery,
    setSearchQuery,
    selectedRegion,
    setSelectedRegion,
    selectedStatus,
    setSelectedStatus
  } = useCountriesFilters(allCountries);
  
  // Pagination
  const {
    paginatedCountries,
    currentPage,
    setCurrentPage,
    itemsPerPage,
    setItemsPerPage,
    totalItems,
    totalPages
  } = useCountriesPagination(filteredCountries, searchQuery, selectedRegion, selectedStatus);
  
  // Actions
  const {
    editing,
    editData,
    dialogOpen,
    selectedCountry,
    setEditData,
    handleToggleActive,
    handleEdit,
    handleSaveEdit,
    handleDelete,
    handleOpenDialog,
    handleCloseDialog,
    handleSaveCountryDialog
  } = useCountriesActions(allCountries, setCountries);

  return {
    countries: paginatedCountries,
    isLoading,
    editing,
    editData,
    dialogOpen,
    selectedCountry,
    setEditData,
    handleToggleActive,
    handleEdit,
    handleSaveEdit,
    handleDelete,
    setCountries,
    handleOpenDialog,
    handleCloseDialog,
    handleSaveCountryDialog,
    // Pagination
    currentPage,
    totalPages,
    itemsPerPage,
    totalItems,
    setCurrentPage,
    setItemsPerPage,
    // Filter and search
    searchQuery,
    setSearchQuery,
    selectedRegion,
    setSelectedRegion,
    selectedStatus,
    setSelectedStatus
  };
};
